
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import upload from "@/components/upload/src/index.vue";
  import {itemDetail, updateItemDetail} from '@/services/api';

  @Component({
    components: {
      'zf-breadcrumb': breadcrumb,
      'zf-upload': upload
    },
  })
  export default class ItemModify extends Vue{
    //面包屑导航
    public navList: {name: String, to?: String}[] = [
      {name: '审核列表', to: '/item/list'},
      {name: 'item修改'}
    ];
    //编辑的itemId
    private itemId!: number;
    //显示的表单信息
    public itemForm: any = {
      id: 0,
      assetTitle: '',   //item标题
      assetBody: ''
    };

    created(): void {
      this.itemId = Number(this.$route.query.itemId);
      console.log('itemId:'+this.itemId);
      this.itemDetail();
    }

    /**
     * 获取item信息
     */
    async itemDetail(): Promise<void> {
      if (this.itemId) {
        await itemDetail(this.itemId, true).then(res => {
          if (res.data && res.data.result) {
            this.itemForm = res.data.result;
          }
        });
      }
    }

    /**
     * 保存表单
     */
    onSubmit(itemForm :any): void {
      this.updateItemDetail();
    }

    /**
     * 更新item和套餐信息
     */
    updateItemDetail(): void {
      updateItemDetail(this.itemForm).then(res =>{
        if (res.data && res.data.status==='OK'){
          this.$message({
            showClose: true,
            message: '修改成功！',
            type: 'success'
          });
          // 保存成功页面等待1秒重新加载数据
          let self = this;
          setTimeout(function () {
            self.itemDetail();
          }, 1000);
        }else {
          this.$message({
            showClose: true,
            message: '修改失败，请检查网络后重试！',
            type: 'warning'
          });
        }
      });
    };

    /**
     * 取消方法
     */
    cancel() {
      this.$router.push('/');
    }
  }
